import { useEffect, useState } from 'react';

import { useDialogCrup } from '../../../../../shared/hooks/DialogCrup';
import { getDecreeText } from '../../../../../shared/utils/invoice';

import { DeclareRegisterInvoiceService as Service } from '../../DeclareRegisterInvoiceService';

import { TokenElement } from './token-element';
import { ServiceProvider } from './service-provider';
import { ReceivingUnitInformation } from './receiving-unit-information';
import { AllowanceAccessInfo } from './allowance-access-info';
import { EInvoiceIntegrationRequest } from './eInvoice-integration-request';
import { EInvoiceSuspensionRequest } from './eInvoice-suspension-request';
import _ from 'lodash';
import moment from 'moment';
import { Button } from 'primereact/button';
import GuideEInvoiceSuspensionRequest from './guide-eInvoice-suspension-request';
import { useTranslation } from '../../../../../shared/language';


export const CrupND70 = ({
  header,
  dataKey,
  tokens,
  setTokens,
  serviceProvider,
  setServiceProvider,
  receivingUnitInformation,
  setReceivingUnitInformation,
  allowanceAccessInfo,
  setAllowanceAccessInfo,
  eInvoiceIntegrationRequest,
  setEInvoiceIntegrationRequest,
  eInvoiceSuspensionRequest,
  setEInvoiceSuspensionRequest,
  reloadTokens,
  refreshLazyData,
  lastDeclaration,
  cloneMode = false,
}) => {
  const [providerOptions, setProviderOptions] = useState([]);
  const [receivingUnitOptions, setReceivingUnitOptions] = useState([]);
  const [visibleGuideEInvoiceSuspensionRequest, setVisibleGuideEInvoiceSuspensionRequest] = useState(false);
  const { t } = useTranslation();

  const formatData = (data) => {
    if (data.formInvoice) {
      data.formInvoice = data.formInvoice.join(',');
    }
    if (data.formSendData) {
      data.formSendData = data.formSendData.join(',');
    }
    if (data.invoiceTypeUse) {
      data.invoiceTypeUse = data.invoiceTypeUse.join(',');
    }
    if (data.method) {
      data.method = data.method.join(',');
    }
    data.partners = data.partners || [];
    if (serviceProvider.length > 0) {
      data.partners.push(
        ..._.map(serviceProvider, (item) => {
          const formattedItem = {
            ..._.omit(item, ['id']),
            ...item,
            type: 0
          };
          if (formattedItem.fromDate) {
            formattedItem.fromDate = moment(formattedItem.fromDate).format('YYYY-MM-DD');
          }
          if (formattedItem.toDate) {
            formattedItem.toDate = moment(formattedItem.toDate).format('YYYY-MM-DD');
          }
          return formattedItem;
        })
      );
    }
    if (receivingUnitInformation.length > 0) {
      data.partners.push(
        ..._.map(receivingUnitInformation, (item) => {
          const formattedItem = {
            ..._.omit(item, ['id']),
            ...item,
            type: 1
          };
          if (formattedItem.fromDate) {
            formattedItem.fromDate = moment(formattedItem.fromDate).format('YYYY-MM-DD');
          }
          if (formattedItem.toDate) {
            formattedItem.toDate = moment(formattedItem.toDate).format('YYYY-MM-DD');
          }
          return formattedItem;
        })
      );
    }
    if (allowanceAccessInfo.length > 0) {
      data.dependentUnits = allowanceAccessInfo.map(item => ({
        ...item,
        fromDate: moment(item.fromDate).format('YYYY-MM-DD'),
        toDate: moment(item.toDate).format('YYYY-MM-DD')
      }))
    }
    if (eInvoiceIntegrationRequest.length > 0) {
      data.integrations = eInvoiceIntegrationRequest
    }
    if (eInvoiceSuspensionRequest.length > 0) {
      data.suspensions = eInvoiceSuspensionRequest.map(item => ({
        ...item,
        fromDate: moment(item.fromDate).format('YYYY-MM-DD'),
        toDate: moment(item.toDate).format('YYYY-MM-DD')
      }));
    }
    data.token = tokens;
    return data;
  }

  const { render, create, update, getValue, setValue, touched } = useDialogCrup({
    header,
    dataKey,
    width: '85rem',
    fields: [
      { field: 'cityCode', type: 'hidden' },
      { field: 'cityName', type: 'hidden' },
      { field: 'taxAuthorityCode', type: 'hidden' },
      { field: 'sourceDeclarationId', type: 'hidden' },
      { type: 'custom', className: 'md:col-12 text-center mb-0', body: <h2 className="mb-0">{t('common.declarationFormTitle')}</h2> },
      { type: 'custom', className: 'md:col-12 text-center', body: <h5>{t('common.declarationFormSubtitle')}</h5> },
      {
        field: 'formality', type: 'RadioButton', wrapName: 'justify-content-center', RadioButtonProps: {
          RadioButtons: [
            { className: 'md:col-2', value: 1, label: t('common.declarationRegisterNew') },
            { className: 'md:col-2', value: 2, label: t('common.declarationChangeInfo') }
          ]
        }
      },
      { field: 'dateCreate', header: t('common.declarationDate'), required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'region', header: t('common.placeOfCreation'), required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'taxpayers', header: t('common.taxpayerName'), required: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxCode', header: t('common.taxCode'), required: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxAuthorityName', header: t('common.managedTaxAuthority'), required: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      {
        type: 'custom', className: 'md:col-12 text-center', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">{t('common.legalRepresentativeNotice')}</span>
            </div>
          </div>
        )
      },
      { field: 'legalRepName', header: t('common.legalRepresentativeName'), required: true, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepPhone', header: t('system.legalRepresentativePhone'), required: true, InputTextProps: { maxLength: 16 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepIdentificationNumber', header: t('common.citizenId'), InputTextProps: { maxLength: 12 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepPassport', header: t('common.passportLabel'), InputTextProps: { maxLength: 20 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepDob', header: t('common.dateOfBirth'), required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', CalendarProps: { maxDate: new Date() } },
      { field: 'legalRepGender', header: t('common.gender'), type: 'Dropdown', required: true, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', DropdownProps: { options: [{ value: 0, label: t('common.female') }, { value: 1, label: t('common.male') }], filter: true }, },

      {
        type: 'custom', className: 'md:col-12 text-center', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">{t('common.acceptedDeclarationNotice')}</span>
            </div>
          </div>
        )
      },
      { field: 'personContact', header: t('common.contactPerson'), required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'phone', header: t('common.contactPhone'), required: true, InputTextProps: { maxLength: 20 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'address', header: t('common.contactAddress'), required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'email', type: 'email', header: t('common.contactEmail'), required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9' },
      {
        type: 'template',
        className: 'md:col-12',
        template: (item) => <p>{getDecreeText(item?.dateCreate)}</p>
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceFormSection')}</b>
      },
      {
        field: 'formInvoice', header: t('common.invoiceForm'), required: true, type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            { value: 'CMa', translationKey: 'common.invoiceWithTaxCode' },
            { value: 'CMTMTTien', translationKey: 'common.invoiceWithCashRegister' },
            { value: 'KMa', translationKey: 'common.invoiceWithoutTaxCode' }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceDataSendingSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12 text-center pl-4', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">{t('common.skipIfNotApplicable')}</span>
            </div>
          </div>
        )
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">{t('common.codedInvoiceWithoutServiceFeeCase')}</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'DBKK', translationKey: 'common.difficultAreaBusiness', disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && item.formInvoice.includes('KMa');
              }
            },
            {
              value: 'UBND',
              translationKey: 'common.otherSmallBusiness',
              disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && item.formInvoice.includes('KMa');
              }
            },
            {
              value: 'TSC',
              translationKey: 'common.publicAssetAuthority',
              disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">{t('common.noCodeInvoiceCase')}</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [

            {
              value: 'TVAN', translationKey: 'common.viaInvoiceProvider', disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            },
            {
              value: 'GTT', translationKey: 'common.directToTaxAuthority', disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            },
            // {
            //   value: 'NN', label: 'Nhà cung cấp ở nước ngoài không có cơ sở thường trú tại Việt Nam hoạt động thương mại điện tử, kinh doanh trên nền tảng số và các dịch vụ khác tại Việt Nam (điểm a.1 khoản 3 Nghị định)', disabledDependency: (item) => {
            //     return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
            //   }
            // },
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.dataTransferMethodSection')}</b>
      },
      {
        field: 'method', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'CDDu', translationKey: 'common.fullInvoiceContent', disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('CMTMTTien'));
              }
            },
            {
              value: 'CBTH', translationKey: 'common.summaryInvoiceData', disabledDependency: (item) => {
                return !cloneMode && item.formInvoice && !item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceTypeUseSection')}</b>
      },
      {
        field: 'invoiceTypeUse', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            { value: 'GTGT', label: t('common.vatInvoice') },
            { value: 'HDBH', label: t('common.salesInvoice') },
            { value: 'HDBTSCong', label: t('common.publicAssetInvoice') },
            { value: 'HDBHDTQGia', label: t('common.nationalReserveInvoice') },
            { value: 'HDK', label: t('common.otherInvoiceTypes') },
            { value: 'CTu', label: t('common.managedDocumentsAsInvoice') },
            { value: 'GTGTBL', label: t('common.integratedVatReceipt') },
            { value: 'BHBL', label: t('common.integratedSalesReceipt') },
            { value: 'HDTM', label: t('common.commercialInvoice') },
            // { value: 'HDNN', label: 'Hóa đơn nhà cung cấp ở nước ngoài không có cơ sở thường trú tại Việt Nam' },
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.certificateUseSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <TokenElement tokens={tokens} setTokens={setTokens} reloadTokens={reloadTokens} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.serviceProviderSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <ServiceProvider items={serviceProvider} setItems={setServiceProvider} options={providerOptions} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.receivingUnitSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <ReceivingUnitInformation items={receivingUnitInformation} setItems={setReceivingUnitInformation} options={receivingUnitOptions} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.dependentUnitSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <AllowanceAccessInfo items={allowanceAccessInfo} setItems={setAllowanceAccessInfo} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <>
          <b>{t('common.suspensionRequestSection')} <span className='text-blue-500 cursor-pointer' onClick={() => setVisibleGuideEInvoiceSuspensionRequest(true)}><span className="pi pi-question-circle"></span> {t('common.guide')}</span></b>
        </>
      },
      {
        type: 'custom', className: 'md:col-12', body: <>
          <EInvoiceSuspensionRequest items={eInvoiceSuspensionRequest} setItems={setEInvoiceSuspensionRequest} options={providerOptions} tokens={tokens} />
          <GuideEInvoiceSuspensionRequest visible={visibleGuideEInvoiceSuspensionRequest} setVisible={setVisibleGuideEInvoiceSuspensionRequest} />
        </>
      },
    ],
    // Khi lưu tờ khai, chỉ gọi API lưu dữ liệu; không tự động ký và gửi CQT.
    createItem: (item) => Service.create(formatData(item)),
    updateItem: (id, item) => {
      return Service.update(id, formatData(item));
    },
    refreshLazyData,
    layout: 'Horizontal',
    formClassName: 'paper',
    submitLabel: t('common.save'),
  });

  const { formInvoice } = getValue();


  useEffect(() => {
    if (lastDeclaration?.partners) {
      setServiceProvider(
        lastDeclaration.partners
          .filter(item => item.type === 0)
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate
          })) || []
      )
      setReceivingUnitInformation(
        lastDeclaration.partners
          .filter(item => item.type === 1).map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate
          })) || [])
      setAllowanceAccessInfo(
        lastDeclaration.dependentUnits
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate,
          })) || [])
      setEInvoiceSuspensionRequest(
        lastDeclaration.suspensions
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate,
          })) || [])
    }
  }, [lastDeclaration])

  useEffect(() => {
    if (formInvoice && touched) {
      if (formInvoice.length >= 1 && formInvoice.includes('KMa')) {
        const value = { ...getValue() };
        value.formSendData = ['TVAN'];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('CMa') || formInvoice.includes('CMTMTTien')) {
        const value = { ...getValue() };
        value.formSendData = [];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('KMa')) {
        const value = { ...getValue() };
        value.formSendData = ['TVAN'];
        value.method = [];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      }
    }
  }, [formInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    Service.getPartnerOptions().then((response) => {
      const options = Array.isArray(response) ? response : (response?.items || []);
      const providerOptions = Array.isArray(response?.serviceProviders)
        ? response.serviceProviders
        : options.filter(item => item.type === 0);
      const receivingUnitOptions = Array.isArray(response?.receivingUnits)
        ? response.receivingUnits
        : options.filter(item => item.type === 1);
      setProviderOptions(providerOptions);
      setReceivingUnitOptions(receivingUnitOptions);
    });
  }, []);

  return { render, create, update, setValue };
}
